module.exports = __webpack_public_path__ + "static/img/lartneList_img_5.7b56a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/lartneList/lartneList_img_5.png
// module id = ow7V
// module chunks = 1